import {
    Component,
    EventEmitter, Input, Output, TemplateRef, ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'dynamic-dialog',
    templateUrl: './dynamic-dialog.component.html',
    styleUrl: './dynamic-dialog.component.scss',
    imports: [
        NgIf,
        MatButton,
        MatDialogClose,
    ],
})
export class DynamicDialogComponent {
    /**
     * Reference to template
     */
    @ViewChild('template') template?: TemplateRef<any>;

    /**
     * Max width of dialog
     */
    @Input() maxWidth = 400;

    /**
     * Emit on close
     */
    @Output() onClose = new EventEmitter<any>();

    /**
     * Set to false to disable closing via backdrop click
     */
    @Input() closeOnBackdropClick = true;

    /**
     * Set to false to hide action buttons
     */
    @Input() showActions = true;

    /**
     * Reference to dialog
     */
    dialogRef?: MatDialogRef<any>;

    constructor(private dialog: MatDialog) { }

    /**
     * Opens the dialog
     */
    async open(): Promise<boolean> {
        if (this.template) {
            this.dialogRef = this.dialog.open(this.template, {
                autoFocus: false,
                // Make sure there is always some padding to the edge of the screen
                maxWidth: `min(${this.maxWidth}px, calc(100vw - 64px))`,
                disableClose: !this.closeOnBackdropClick,
            });
            const result = await firstValueFrom(this.dialogRef.afterClosed());
            this.onClose.next(!!result);
            return !!result;
        }
        return false;
    }

    /**
     * Closes dialog if dialog is currently open
     */
    close(): void {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }
}
